<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="mb-3 page-title">
      <i class="bi bi-flag-fill"></i> Data Kontingen
    </div>

    <!-- Filter & Action Toolbar -->
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
      <div class="d-flex flex-wrap align-items-center gap-2 flex-grow-1">
        <DataToolbar
          v-model="searchQuery"
          placeholder="Cari nama kontingen, PIC, email, telepon..."
          :mencari="loading"
          @search="searchContingent"
        />

        <select v-model="selectedTournament" @change="loadContingent" class="form-select w-auto" style="min-width: 200px;">
          <option value="">Semua Turnamen</option>
          <option v-for="t in tournaments" :key="t.id" :value="t.id">{{ t.name }}</option>
        </select>
      </div>

      <div class="tool-bar d-flex gap-2">
        <button v-if="permissions && permissions.includes('export contingent')" class="button button-ghost" @click="exportToExcel">
          <i class="bi bi-file-earmark-excel text-success"></i> Ekspor Excel
        </button>
        <router-link to="/admin/contingent/create" class="button button-primary">
          <i class="bi bi-plus-lg"></i> Tambah Kontingen
        </router-link>
      </div>
    </div>

    <!-- Table to display contingent data -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="number-column">No</th>
            <th>Turnamen</th>
            <th>Nama Kontingen</th>
            <th>Penanggung Jawab</th>
            <th>Atlet</th>
            <th class="text-end">Aksi</th>
          </tr>
        </thead>
        <tbody v-if="contingents.length > 0">
          <tr v-for="(contingent, index) in contingents" :key="contingent.id">
            <td class="number-column">{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td class="kolom-turnamen"><strong>{{ contingent.tournament_name || '-' }}</strong></td>
            <td>{{ contingent.name }}</td>
            <td class="kolom-pic">
              <strong>{{ contingent.pic_name || '-' }}</strong>
              <small>{{ contingent.pic_phone || '-' }}</small>
              <small>{{ contingent.pic_email || '-' }}</small>
            </td>
            <td>
              <button
                type="button"
                class="badge-atlet-btn"
                @click="bukaAnggotaKontingen(contingent)"
                title="Klik untuk melihat daftar atlet kontingen ini"
              >
                <i class="bi bi-people-fill"></i>
                <span>{{ contingent.team_members_count || 0 }} Atlet</span>
                <i class="bi bi-chevron-right badge-atlet-arrow"></i>
              </button>
            </td>
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
                <MenuAksi v-slot="{ tutup }">
                  <button type="button" class="aksi__item"
                          @click="tutup(); bukaAnggotaKontingen(contingent)">
                    <i class="bi bi-people text-primary"></i> Lihat Atlet ({{ contingent.team_members_count || 0 }})
                  </button>
                  <button type="button" class="aksi__item"
                          @click="tutup(); EditContingent(contingent.id)">
                    <i class="bi bi-pencil-square"></i> Ubah Kontingen
                  </button>
                  <button type="button" class="aksi__item aksi__item--bahaya" v-if="permissions && permissions.includes('delete contingent')"
                          @click="tutup(); confirmDelete(contingent.id, contingent.name)">
                    <i class="bi bi-trash"></i> Hapus
                  </button>
                </MenuAksi>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center py-4 text-muted">Belum ada data kontingen.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ══════════════ MODAL DAFTAR ANGGOTA ATLET KONTINGEN ══════════════ -->
    <div
      v-if="modalAnggotaTerbuka"
      class="modal-backdrop-custom"
      @click.self="tutupModalAnggota"
    >
      <div class="modal-card-custom">
        <!-- Header Modal -->
        <div class="modal-card-custom__header">
          <div class="d-flex align-items-center gap-3">
            <div class="modal-header-icon">
              <i class="bi bi-people-fill"></i>
            </div>
            <div>
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <h3 class="modal-card-custom__title">{{ kontingenDipilih?.name }}</h3>
                <span class="badge bg-primary-subtle text-primary fw-bold">
                  {{ kontingenDipilih?.tournament_name || 'Turnamen' }}
                </span>
              </div>
              <p class="modal-card-custom__subtitle">
                PIC: <strong>{{ kontingenDipilih?.pic_name || '-' }}</strong>
                <span v-if="kontingenDipilih?.pic_phone" class="ms-2">
                  <i class="bi bi-telephone"></i> {{ kontingenDipilih.pic_phone }}
                </span>
                <span v-if="kontingenDipilih?.pic_email" class="ms-2">
                  <i class="bi bi-envelope"></i> {{ kontingenDipilih.pic_email }}
                </span>
              </p>
            </div>
          </div>
          <button type="button" class="btn-close-modal" @click="tutupModalAnggota" aria-label="Tutup">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- Filter & Search Toolbar Modal -->
        <div class="modal-card-custom__toolbar">
          <div class="search-box-modal">
            <i class="bi bi-search"></i>
            <input
              type="text"
              v-model="pencarianAnggota"
              placeholder="Cari nama atlet, kelas, nomor seni..."
              class="search-input-modal"
            />
            <button v-if="pencarianAnggota" @click="pencarianAnggota = ''" class="btn-clear-search">
              <i class="bi bi-x"></i>
            </button>
          </div>

          <div class="filter-pills-modal">
            <button
              type="button"
              class="pill-btn"
              :class="{ 'is-active': filterJenisAnggota === 'semua' }"
              @click="filterJenisAnggota = 'semua'"
            >
              Semua ({{ anggotaList.length }})
            </button>
            <button
              type="button"
              class="pill-btn"
              :class="{ 'is-active': filterJenisAnggota === 'tanding' }"
              @click="filterJenisAnggota = 'tanding'"
            >
              Tanding ({{ hitungJenisAnggota('tanding') }})
            </button>
            <button
              type="button"
              class="pill-btn"
              :class="{ 'is-active': filterJenisAnggota === 'seni' }"
              @click="filterJenisAnggota = 'seni'"
            >
              Seni ({{ hitungJenisAnggota('seni') }})
            </button>
            <button
              type="button"
              class="pill-btn"
              :class="{ 'is-active': filterGenderAnggota === 'male' }"
              @click="filterGenderAnggota = filterGenderAnggota === 'male' ? '' : 'male'"
            >
              <i class="bi bi-gender-male text-primary"></i> Putra
            </button>
            <button
              type="button"
              class="pill-btn"
              :class="{ 'is-active': filterGenderAnggota === 'female' }"
              @click="filterGenderAnggota = filterGenderAnggota === 'female' ? '' : 'female'"
            >
              <i class="bi bi-gender-female text-danger"></i> Putri
            </button>
          </div>
        </div>

        <!-- Body Modal (Daftar Atlet) -->
        <div class="modal-card-custom__body">
          <div v-if="memuatAnggota" class="text-center py-5 text-muted">
            <span class="spinner-border text-primary me-2"></span>
            Memuat daftar atlet kontingen...
          </div>

          <div v-else-if="anggotaTersaring.length === 0" class="empty-state-modal py-5 text-center">
            <div class="empty-icon mb-3">
              <i class="bi bi-person-x fs-1 text-muted"></i>
            </div>
            <h5 class="fw-bold text-primary mb-1">
              {{ pencarianAnggota || filterJenisAnggota !== 'semua' || filterGenderAnggota ? 'Tidak ada atlet yang cocok dengan filter.' : 'Belum ada atlet yang didaftarkan di kontingen ini.' }}
            </h5>
            <p class="text-secondary small mb-3">
              {{ pencarianAnggota || filterJenisAnggota !== 'semua' || filterGenderAnggota ? 'Coba ubah kata kunci pencarian atau reset filter di atas.' : 'Klik tombol di bawah untuk mendaftarkan atlet baru.' }}
            </p>
            <router-link
              v-if="!pencarianAnggota && filterJenisAnggota === 'semua' && !filterGenderAnggota"
              :to="{ path: '/admin/team-members/create', query: { contingent_id: kontingenDipilih?.id, tournament_id: kontingenDipilih?.tournament_id } }"
              class="button button-primary mx-auto"
            >
              <i class="bi bi-person-plus-fill"></i> Tambah Atlet Pertama
            </router-link>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th class="number-column">No</th>
                  <th>Atlet</th>
                  <th>Pertandingan</th>
                  <th>Kategori & Kelas</th>
                  <th>BB / TB</th>
                  <th class="text-end">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(atlet, idx) in anggotaTersaring" :key="atlet.id">
                  <td class="number-column text-muted fw-bold">{{ idx + 1 }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-2.5">
                      <div class="atlet-avatar">
                        <img v-if="atlet.photo_url" :src="atlet.photo_url" alt="Foto" class="atlet-avatar-img" />
                        <span v-else class="atlet-avatar-initial">{{ inisialNama(atlet.name) }}</span>
                      </div>
                      <div>
                        <strong class="d-block text-primary">{{ atlet.name }}</strong>
                        <div class="d-flex align-items-center gap-1.5 mt-0.5">
                          <span class="badge" :class="atlet.gender === 'female' ? 'bg-danger-subtle text-danger' : 'bg-primary-subtle text-primary'">
                            {{ atlet.gender === 'female' ? 'Putri' : 'Putra' }}
                          </span>
                          <span class="text-muted small" v-if="atlet.birth_date">
                            ({{ hitungUsia(atlet.birth_date) }} thn)
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="badge" :class="adalahTanding(atlet) ? 'bg-warning-subtle text-warning-emphasis' : 'bg-info-subtle text-info-emphasis'">
                      {{ adalahTanding(atlet) ? 'TANDING' : 'SENI' }}
                    </span>
                    <small class="d-block text-muted mt-0.5" v-if="atlet.championship_category">
                      {{ atlet.championship_category.name }}
                    </small>
                  </td>
                  <td>
                    <strong class="d-block text-primary">
                      {{ atlet.age_category ? atlet.age_category.name : '-' }}
                    </strong>
                    <small class="text-secondary" v-if="adalahTanding(atlet)">
                      {{ atlet.category_class ? atlet.category_class.name + ' (' + atlet.category_class.weight_min + '-' + atlet.category_class.weight_max + ' kg)' : 'Kelas belum dipilih' }}
                    </small>
                    <small class="text-secondary" v-else>
                      {{ gantiTingkatUntuk(atlet.match_category?.name, kontingenDipilih?.tournament_id || selectedTournament) || (atlet.tim_seni ? 'Tim: ' + (atlet.tim_seni.nama || atlet.tim_seni.nama_tim) : 'Seni') }}
                    </small>
                  </td>
                  <td>
                    <span class="d-block fw-bold text-primary">
                      {{ atlet.body_weight ? atlet.body_weight + ' kg' : '-' }}
                    </span>
                    <small class="text-muted" v-if="atlet.body_height">
                      {{ atlet.body_height }} cm
                    </small>
                  </td>
                  <td class="text-end">
                    <div class="d-flex align-items-center justify-content-end gap-1.5">
                      <router-link
                        :to="`/admin/team-members/edit/${atlet.id}`"
                        class="btn btn-sm btn-outline-secondary"
                        title="Ubah Data Atlet"
                      >
                        <i class="bi bi-pencil-square"></i>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Footer Modal -->
        <div class="modal-card-custom__footer">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
            <span class="text-secondary small fw-medium">
              Menampilkan <strong>{{ anggotaTersaring.length }}</strong> dari <strong>{{ anggotaList.length }}</strong> total atlet
            </span>
            <div class="d-flex align-items-center gap-2">
              <router-link
                :to="{ path: '/admin/team-members/create', query: { contingent_id: kontingenDipilih?.id, tournament_id: kontingenDipilih?.tournament_id } }"
                class="button button-primary"
              >
                <i class="bi bi-plus-lg"></i> Tambah Atlet
              </router-link>
              <button type="button" class="button button-ghost" @click="tutupModalAnggota">
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page-url="prevPageUrl"
        :next-page-url="nextPageUrl"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { gantiTingkatUntuk, muatLabelTingkat } from "@/utils/tingkat";
import API from "@/config/api";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { useToast } from "vue-toastification";
import { inject } from 'vue';
import DataToolbar from "@/components/ui/DataToolbar.vue";
import { useConfirm } from "@/composables/useConfirm";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "ContingentList",

  components: { MenuAksi, DataToolbar, AppPagination },

  data() {
    return {
      contingentId: null,
      selectedTournament: '', // Untuk filter
      contingents: [],
      searchQuery: "", // User's search input
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,

      // State Modal Atlet Kontingen
      modalAnggotaTerbuka: false,
      kontingenDipilih: null,
      anggotaList: [],
      memuatAnggota: false,
      pencarianAnggota: '',
      filterJenisAnggota: 'semua',
      filterGenderAnggota: '',
    };
  },

  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []);
    const { konfirmasi, sibuk } = useConfirm();

    return { toast, permissions, konfirmasi, sibuk };
  },
  async mounted() {
    muatLabelTingkat();
    await this.loadTournaments(); // Pastikan daftar turnamen udah ready
    this.loadContingent();
  },
  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
    anggotaTersaring() {
      let daftar = this.anggotaList;

      if (this.filterJenisAnggota !== 'semua') {
        daftar = daftar.filter((a) => {
          const isTanding = this.adalahTanding(a);
          return this.filterJenisAnggota === 'tanding' ? isTanding : !isTanding;
        });
      }

      if (this.filterGenderAnggota) {
        daftar = daftar.filter((a) => a.gender === this.filterGenderAnggota);
      }

      const q = this.pencarianAnggota.trim().toLowerCase();
      if (q) {
        daftar = daftar.filter((a) => {
          const nama = (a.name || '').toLowerCase();
          const usia = (a.age_category?.name || '').toLowerCase();
          const kelas = (a.category_class?.name || '').toLowerCase();
          const matchCat = (a.match_category?.name || '').toLowerCase();
          const tim = (a.tim_seni?.nama || a.tim_seni?.nama_tim || '').toLowerCase();
          return nama.includes(q) || usia.includes(q) || kelas.includes(q) || matchCat.includes(q) || tim.includes(q);
        });
      }

      return daftar;
    },
  },
  methods: {
    gantiTingkatUntuk,
    async loadTournaments() {
      try {
        const res = await axios.get("/tournaments/active", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        this.tournaments = res.data;
      } catch (err) {
        console.error("Gagal load tournament:", err);
      }
    },

    async confirmDelete(id, nama = "") {
      const setuju = await this.konfirmasi({
        judul: "Hapus Kontingen?",
        pesan: `Kontingen "${nama}" akan dihapus permanen beserta data terkait.`,
        tipe: "danger",
        teksKonfirmasi: "Ya, Hapus",
      });
      if (setuju) {
        this.deleteContingent(id);
      }
    },

    async exportToExcel() {
      try {
        // Ekspor mengikuti filter yang sedang dipilih (event dan pencarian).
        const res = await axios.get("/contingents/export", {
          params: {
            tournament_id: this.selectedTournament || undefined,
            search: this.searchQuery.trim() || undefined,
          },
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `contingents-${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (err) {
        this.toast.error("Gagal mengekspor data kontingen.");
      }
    },
    
    async loadContingent(page = 1) {
      this.loading = true;
      try {
        const response = await axios.get("/contingents", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
            tournament_id: this.selectedTournament || undefined,
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.contingents = data;
        this.currentPage = current_page;
        this.totalPages = last_page;
        this.nextPageUrl = next_page_url;
        this.prevPageUrl = prev_page_url;
        this.loading = false;
      } catch (error) {
        console.error("Error loading contingents:", error);
      } finally {
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadContingent(page);
      }
    },

    searchContingent(teks) {
      if (typeof teks === "string") this.searchQuery = teks;
      this.currentPage = 1;
      this.loadContingent();
    },

    EditContingent(id) {
      this.$router.push({ name: "EditContingent", params: { id } });
    },

    async deleteContingent(id) {
      this.sibuk(true);
      try {
        await axios.delete(`/contingents/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        });
        this.toast.success("Kontingen berhasil dihapus.");
        this.loadContingent(this.currentPage);
      } catch (error) {
        const pesan =
          error?.response?.data?.message ||
          error?.friendlyMessage ||
          "Gagal menghapus kontingen.";
        this.toast.error(pesan);
      } finally {
        this.sibuk(false);
      }
    },

    // ── Logika Modal Anggota Atlet ──
    async bukaAnggotaKontingen(contingent) {
      this.kontingenDipilih = contingent;
      this.modalAnggotaTerbuka = true;
      this.pencarianAnggota = '';
      this.filterJenisAnggota = 'semua';
      this.filterGenderAnggota = '';
      this.memuatAnggota = true;
      this.anggotaList = [];

      try {
        const res = await axios.get(`/contingents/${contingent.id}/members`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        this.anggotaList = res.data.members || [];
      } catch (err) {
        console.error("Gagal memuat atlet kontingen:", err);
        const errMsg = err.response?.data?.message || "Gagal memuat data atlet kontingen.";
        this.toast.error(errMsg);
      } finally {
        this.memuatAnggota = false;
      }
    },

    tutupModalAnggota() {
      this.modalAnggotaTerbuka = false;
      this.kontingenDipilih = null;
      this.anggotaList = [];
    },

    adalahTanding(atlet) {
      const matchCat = atlet.match_category?.name?.toLowerCase() || '';
      const champCat = atlet.championship_category?.name?.toLowerCase() || '';
      return matchCat.includes('tanding') || champCat.includes('tanding') || Boolean(atlet.category_class_id);
    },

    hitungJenisAnggota(jenis) {
      return this.anggotaList.filter((a) => {
        const isTanding = this.adalahTanding(a);
        return jenis === 'tanding' ? isTanding : !isTanding;
      }).length;
    },

    inisialNama(nama) {
      return (nama || '?')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((k) => k[0])
        .join('')
        .toUpperCase();
    },

    hitungUsia(tglLahir) {
      if (!tglLahir) return '-';
      const lahir = new Date(tglLahir);
      const sekarang = new Date();
      let usia = sekarang.getFullYear() - lahir.getFullYear();
      const m = sekarang.getMonth() - lahir.getMonth();
      if (m < 0 || (m === 0 && sekarang.getDate() < lahir.getDate())) {
        usia--;
      }
      return usia;
    },
  },
};
</script>

<style scoped>
.kolom-pic { white-space: normal; line-height: 1.3; }
.kolom-pic strong, .kolom-pic small { display: block; }
.kolom-pic small { color: var(--text-muted); word-break: break-all; }


.badge-atlet-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  font-family: var(--font-sans);
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--accent);
  background: var(--accent-subtle);
  border: 1px solid rgba(240, 80, 8, 0.25);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.badge-atlet-btn:hover {
  background: var(--accent);
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px -2px rgba(240, 80, 8, 0.35);
}

.badge-atlet-arrow {
  font-size: 0.7rem;
  transition: transform var(--transition-fast);
}

.badge-atlet-btn:hover .badge-atlet-arrow {
  transform: translateX(2px);
}

/* ── Custom Modal Backdrop & Card ── */
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-card-custom {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-2xl, 20px);
  box-shadow: var(--shadow-2xl, 0 25px 50px -12px rgba(0, 0, 0, 0.25));
  width: 100%;
  max-width: 960px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: modal-masuk 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modal-masuk {
  from { opacity: 0; transform: scale(0.96) translateY(8px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.modal-card-custom__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: var(--bg-sunken);
  border-bottom: 1px solid var(--border-subtle);
}

.modal-header-icon {
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: var(--radius-lg, 12px);
  background: linear-gradient(135deg, rgba(240, 80, 8, 0.15) 0%, rgba(248, 168, 8, 0.2) 100%);
  border: 1px solid rgba(240, 80, 8, 0.25);
  color: var(--accent);
  display: grid;
  place-items: center;
  font-size: 1.25rem;
}

.modal-card-custom__title {
  font-family: var(--font-sans);
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.modal-card-custom__subtitle {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin: 0.2rem 0 0;
}

.btn-close-modal {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  color: var(--text-secondary);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn-close-modal:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
  transform: scale(1.05);
}

/* Toolbar inside modal */
.modal-card-custom__toolbar {
  padding: 1rem 1.5rem;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-subtle);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
}

.search-box-modal {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 260px;
  flex-grow: 1;
}

.search-box-modal i.bi-search {
  position: absolute;
  left: 12px;
  color: var(--text-muted);
  font-size: 0.9rem;
  pointer-events: none;
}

.search-input-modal {
  width: 100%;
  padding: 0.5rem 2rem 0.5rem 2.25rem;
  font-family: var(--font-sans);
  font-size: 0.875rem;
  background: var(--bg-sunken);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  outline: none;
  transition: all var(--transition-fast);
}

.search-input-modal:focus {
  border-color: var(--accent);
  background: var(--bg-surface);
  box-shadow: 0 0 0 3px rgba(240, 80, 8, 0.15);
}

.btn-clear-search {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
}

.filter-pills-modal {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.pill-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0.4rem 0.85rem;
  font-family: var(--font-sans);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.pill-btn:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.pill-btn.is-active {
  background: var(--accent);
  color: #ffffff;
  border-color: var(--accent);
  box-shadow: 0 2px 8px -1px rgba(240, 80, 8, 0.35);
}

/* Modal Body */
.modal-card-custom__body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.atlet-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  overflow: hidden;
  display: grid;
  place-items: center;
}

.atlet-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.atlet-avatar-initial {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--accent);
}

/* Modal Footer */
.modal-card-custom__footer {
  padding: 1rem 1.5rem;
  background: var(--bg-sunken);
  border-top: 1px solid var(--border-subtle);
}
</style>
